import { render, staticRenderFns } from "./LiquidationsList.vue?vue&type=template&id=76bb4f0a&"
import script from "./LiquidationsList.vue?vue&type=script&lang=js&"
export * from "./LiquidationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports